import moment from 'moment'
import { useCartStore } from '~/stores/cart'
// const cartStore = useCartStore()

const calculateAgeInMonths = (birthDate) => {
  const now = new Date()
  const birth = new Date(birthDate)
  const years = now.getFullYear() - birth.getFullYear()
  const months = now.getMonth() - birth.getMonth()

  return years * 12 + months
}

const getBirthDateFromPesel = (pesel) => {
  const yearPart = pesel.substring(0, 2)
  const monthPart = pesel.substring(2, 4)
  const dayPart = pesel.substring(4, 6)

  let year = parseInt(yearPart, 10)
  let month = parseInt(monthPart, 10)

  if (month > 12) {
    year += 2000
    month -= 20
  } else {
    year += 1900
  }

  return `${year}-${String(month).padStart(2, '0')}-${dayPart}`
}

export const useChildrenHelper = (patients) => {
  const kids = patients.filter((patient) => {

    if (patient.age !== 'kid') {
      return false
    }

    let birthDate = patient.birth_date

    if (!birthDate && patient.pesel) {
      birthDate = getBirthDateFromPesel(patient.pesel)
    }

    if (!birthDate) {
      return false
    }

    if (moment(birthDate, 'DD.MM.YYYY', true).isValid()) {
      birthDate = moment(birthDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
    }

    const ageInMonths = calculateAgeInMonths(birthDate)

    return ageInMonths >= 3 && ageInMonths <= 36
  })
  return kids.length > 0
}
